import { getUrl } from 'aws-amplify/storage';

import type { AttachmentDownload, AttachmentFileUpload } from 'types';

export type FileType = 'pdf' | 'doc' | 'xls' | 'jpg' | 'png' | 'eml' | 'csv' | 'msg' | 'docx' | 'xlsx' | 'jpeg' | 'txt';

export function parseFileType(type: string, fileName?: string): FileType | undefined {
  if (type.includes('pdf')) {
    return 'pdf';
  } else if (
    type.includes('xls') ||
    type.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
  ) {
    return 'xls';
  } else if (type.includes('doc')) {
    return 'doc';
  } else if (type.includes('jpg') || type.includes('jpeg')) {
    return 'jpg';
  } else if (type.includes('png')) {
    return 'png';
  } else if (type.includes('csv')) {
    return 'csv';
  } else if (type.includes('eml')) {
    return 'eml';
  } else if (type === '' && fileName?.endsWith('msg')) {
    return 'msg';
  }
  return undefined;
}

export function openableFileType(type: string): boolean {
  const fileType = parseFileType(type);
  return fileType === 'pdf' || fileType === 'jpg' || fileType === 'png';
}

export function splitFileName(name: string): [string, string] {
  const split = name.split('.');
  const extension = split.pop() || '';
  const fileName = split.join('.');
  return [fileName, extension];
}

export function getFileNameFromKey(key: string): string {
  return key.split('/').pop() || key;
}

export function getFileName(attachment: AttachmentDownload | AttachmentFileUpload) {
  if ('url' in attachment) {
    if (attachment.url) {
      return getFileNameFromKey(attachment.url);
    } else {
      return getFileNameFromKey(attachment.key);
    }
  }
  return attachment.name;
}

export async function getSignedUrl(key: string) {
  // CONFIRM
  return (await getUrl({ path: key })).url.href;
}
